"use strict";
/* eslint-disable react/jsx-no-bind */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const react_router_dom_1 = require("react-router-dom");
const Check_1 = __importDefault(require("@material-ui/icons/Check"));
const Settings_1 = __importDefault(require("@material-ui/icons/Settings"));
const Add_1 = __importDefault(require("@material-ui/icons/Add"));
const Profile = (props) => {
    const { username, image, workspaces = [], activeWorkspaceId, workspaceTitle = 'Workspaces', workspaceCreationTitle = 'Create new workspace', pathAccount = '/account', pathSettings = '/settings', onLogout, onWorkspaceSwitch, onWorkspaceCreation, handleProfileClose } = props;
    const handleWorkspaceSwitch = (workspaceId) => {
        return () => {
            if (onWorkspaceSwitch) {
                onWorkspaceSwitch(workspaceId);
                return handleProfileClose();
            }
        };
    };
    const handleWorkspaceCreation = () => {
        if (onWorkspaceCreation) {
            onWorkspaceCreation();
            return handleProfileClose();
        }
    };
    const handleLogout = () => {
        if (onLogout) {
            onLogout();
            return handleProfileClose();
        }
    };
    return (react_1.default.createElement("div", { style: { minWidth: 400 } },
        react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Avatar, { src: image, style: { margin: 20, width: 100, height: 100 } })),
            react_1.default.createElement(core_1.Grid, { item: true, style: { marginRight: 20 } },
                react_1.default.createElement(core_1.Typography, { style: { fontSize: '1.3em', lineHeight: 1.1 } }, username),
                react_1.default.createElement(core_1.Link, { variant: "body2", component: react_router_dom_1.Link, to: pathAccount, onClick: handleProfileClose }, "Manage your account"),
                onLogout && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Typography, { variant: "caption", color: "textSecondary" }, "\u00A0\u00A0\u2014\u00A0\u00A0"),
                    react_1.default.createElement(core_1.Link, { variant: "body2", href: "#", onClick: handleLogout }, "Logout"))))),
        workspaces.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Divider, null),
            react_1.default.createElement(core_1.List, { subheader: react_1.default.createElement(core_1.ListSubheader, null, workspaceTitle) }, workspaces.map((w) => (react_1.default.createElement(core_1.ListItem, { key: w.id, button: true, onClick: handleWorkspaceSwitch(w.id) },
                react_1.default.createElement(core_1.ListItemIcon, null, w.id === activeWorkspaceId && react_1.default.createElement(Check_1.default, null)),
                react_1.default.createElement(core_1.ListItemText, { primary: w.name }),
                w.id === activeWorkspaceId && (react_1.default.createElement(core_1.ListItemSecondaryAction, null,
                    react_1.default.createElement(core_1.IconButton, { edge: "end", component: react_router_dom_1.Link, to: pathSettings, onClick: handleProfileClose },
                        react_1.default.createElement(Settings_1.default, null)))))))),
            onWorkspaceCreation && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Divider, null),
                react_1.default.createElement("div", { style: { marginTop: 20, marginBottom: 20, textAlign: 'center' } },
                    react_1.default.createElement(core_1.Button, { onClick: handleWorkspaceCreation, endIcon: react_1.default.createElement(Add_1.default, null) }, workspaceCreationTitle))))))));
};
exports.Profile = Profile;
//# sourceMappingURL=index.js.map